import { render, staticRenderFns } from "./AnnualInstitutionObjectives.vue?vue&type=template&id=545197a5"
import script from "./AnnualInstitutionObjectives.vue?vue&type=script&lang=js"
export * from "./AnnualInstitutionObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports